import { WidgetSettingFC } from "types/Setting";

interface Props {
  editor: WidgetSettingFC<any, any, any>;
  editorInfo: any;
  watchSetting: string;
  watchSettingValue: any;
}

export const HideableSetting: WidgetSettingFC<string, Props> = ({
  info: { editor: Editor, editorInfo, watchSetting, watchSettingValue },
  settings,
  ...rest
}) => {
  const hidden = settings[watchSetting] === watchSettingValue;
  return <>{!hidden && <Editor info={editorInfo} settings={settings} {...rest}></Editor>}</>;
};
